import React from "react";

export default function Stepper({ currentStep }) {
  return (
    <div className="stepper">
      {[1, 2, 3].map((step, index) => (
        <React.Fragment key={step}>
          <div
            className={`step ${
              step < currentStep
                ? "completed"
                : step === currentStep
                ? "active"
                : ""
            }`}
          >
            <div className="circle">
              {step < currentStep ? (
                <span style={{ color: "white" }}>✓</span>
              ) : step === currentStep ? (
                <span className="dot"></span>
              ) : null}
            </div>
            <span>Step {step}</span>
          </div>

          {index < 2 && (
            <div
              className={`line ${
                step < currentStep
                  ? "bg-success"
                  : step === currentStep
                  ? "bg-active"
                  : ""
              }`}
            />
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
